import React from "react";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Tooltip } from "recharts";
import colors from "@/colors";
import { compactNumber, formatPercentage } from "@/helpers/number_format_helper";
import "./style.scss";

const pieColors = [
  colors.primary,
  colors.primaryDark,
  colors.secondary,
  colors.secondaryDark,
  colors.primaryLight,
  colors.secondaryLight,
  colors.green,
  colors.pink,
  colors.skyBlue,
];

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, total } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill} className="font-size-20">
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${compactNumber(
        total
      )}`}</text>
      <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">{`${formatPercentage(
        percent
      )}%`}</text>
    </g>
  );
};

const CustomPieChart = ({ data }) => {
  const total = data.reduce((sum, item) => sum + (Number(item.value) || 0), 0);
  const renderActiveShapeWithTotal = (props) => renderActiveShape({ ...props, total });

  return (
    <div>
      <ResponsiveContainer width="100%" height={data.length > 2 ? data.length * 120 : 330}>
        <PieChart className="margin-auto">
          <Pie
            activeShape={renderActiveShapeWithTotal}
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={90}
            outerRadius={120}
            dataKey="value"
          >
            {data.map((d, index) => (
              <Cell key={index} fill={pieColors[index]} />
            ))}
          </Pie>
          <Tooltip defaultIndex={0} content={() => null} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CustomPieChart;
